module.exports = __webpack_public_path__ + "img/wiaggiare.2077142d.png";